import { render, staticRenderFns } from "./InstitutionSelect.vue?vue&type=template&id=4815b6fc&"
import script from "./InstitutionSelect.vue?vue&type=script&lang=ts&"
export * from "./InstitutionSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports